import axios from 'axios'
import { GetBaseUrl } from '@/utils/ConfigHelper'
import Response from '@/utils/Videomonster/Common/Response'
import { PUBLIC_ERROR_CODE } from '@/utils/Error/Constants'
import { GetPublicErrorCode } from '@/utils/Error/Handler'

/**
 * @param {string} userId 
 * @param {{
 *   from: string;
 *   message: string;
 *   name: string; 
 *   stack: any;
 * }} log 
 * @param {*} deviceInfo 
 * @returns true | false
 */
const PostAppErrorLog = async (userId, log, deviceInfo = {}) => {
    try {
        const url = `${GetBaseUrl()}/api/system/app-error-log`
        const body = { 
            id: userId,
            log: JSON.stringify(log),
            deviceInfo
        }
        const response = await axios.post(url, body)
        const result = (response.status === 200)
        return new Response(result)
    }
    catch (e) {
        const publicErrorCode = GetPublicErrorCode(e)
        switch (publicErrorCode) {
            case PUBLIC_ERROR_CODE.ERR_INVALID_FIELD:
                return new Response(false, publicErrorCode)
            default:
                throw e
        }
    }
}

export default {
    PostAppErrorLog
}